/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br."Knowledge
 * for Decisions (K4D)" and the slogan"Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Long-tail markdown body styling tokens (blockquote, table, code, links, etc.)
 * appended to the head of the body class composed in PolicyPageLayout.tsx.
 */
export const bodyClassTail = [
  // blockquote
  '[&_blockquote]:my-4 [&_blockquote]:py-3 [&_blockquote]:px-4',
  '[&_blockquote]:border-l-3 [&_blockquote]:border-(--border-medium)',
  '[&_blockquote]:text-(--text-secondary) [&_blockquote]:italic',
  '[&_blockquote]:bg-(--surface-secondary) [&_blockquote]:rounded-(--radius-sm)',

  // table
  '[&_table]:w-full [&_table]:border-collapse [&_table]:my-5',
  '[&_table]:text-small [&_table]:overflow-x-auto [&_table]:block [&_table]:max-w-full',
  'max-md:[&_table]:text-meta',
  'max-md:[&_table]:[--webkit-overflow-scrolling:touch]',

  // th, td
  '[&_th]:py-2 [&_th]:px-3 [&_td]:py-2 [&_td]:px-3',
  '[&_th]:border [&_th]:border-(--border-subtle) [&_td]:border [&_td]:border-(--border-subtle)',
  '[&_th]:text-left [&_td]:text-left',
  '[&_th]:leading-normal [&_td]:leading-normal',

  // th specifics
  '[&_th]:bg-(--surface-secondary) [&_th]:font-(--font-semibold) [&_th]:whitespace-nowrap',

  // zebra rows
  '[&_tr:nth-child(even)]:bg-(--surface-secondary)',

  // links (light mode)
  '[&_a]:text-(--seed-base) [&_a]:underline',
  '[&_a]:decoration-[rgb(var(--seed-rgb)/0.3)]',
  '[&_a]:underline-offset-2',
  '[&_a]:transition-[color,text-decoration-color] [&_a]:duration-150 [&_a]:ease-in-out',
  'hover:[&_a]:text-(--link-hover-text) hover:[&_a]:decoration-(--link-hover-text)',

  // links (dark mode)
  '&_a]:text-(--brand-accent)',
  '&_a]:decoration-[rgb(var(--brand-accent-rgb)/0.35)]',
  ':[&_a]:text-(--dark-link-hover-text)',
  ':[&_a]:decoration-(--dark-link-hover-text)',

  // strong
  '[&_strong]:font-(--font-semibold) [&_strong]:text-(--text-primary)',

  // em
  '[&_em]:italic',

  // code (inline)
  '[&_code]:text-[0.85em] [&_code]:py-[0.15em] [&_code]:px-[0.35em]',
  '[&_code]:bg-(--surface-tertiary) [&_code]:rounded-(--radius-sm)',
  '[&_code]:font-[SF_Mono,Fira_Code,Fira_Mono,Roboto_Mono,monospace]',

  // pre
  '[&_pre]:my-4 [&_pre]:p-4',
  '[&_pre]:bg-(--surface-tertiary) [&_pre]:rounded-(--radius-md) [&_pre]:overflow-x-auto',

  // pre > code
  '[&_pre_code]:p-0 [&_pre_code]:bg-transparent',
  '[&_pre_code]:text-small [&_pre_code]:leading-normal',
];
